import ObjectMapper from '@/model/ObjectMapper'

export default class Token {

    static FIELDS = [
        { name: 'token', required: true, check: it => ObjectMapper.checkNonEmptyString(it) },
        { name: 'userid', required: true, check: it => ObjectMapper.checkNumber(it) },
        { name: 'created', required: true, check: it => ObjectMapper.checkNonEmptyString(it) },
        { name: 'modified', required: true },
        { name: 'note', required: true },
        { name: 'domains', required: false, check: it => it instanceof Array }
    ]

    constructor () {
        this.token = ''
        this.userid = -1
        this.created = '1970-01-01 00:00:01Z'
        this.modified = null
        this.note = ''
        this.domains = []
    }

    static fromObject (o) {
        return ObjectMapper.map(o, 'Token', Token.FIELDS)
    }

}
